import { render, staticRenderFns } from "./CertificadoPage.vue?vue&type=template&id=355c9e4e"
import script from "./CertificadoPage.js?vue&type=script&lang=js&external"
export * from "./CertificadoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports